import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.components && _ctx.components.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16))
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}